module.exports = __webpack_public_path__ + "img/empty-categories.0f9a935f.svg";